import { extractFileNameFromUrl } from './dataExtractor';

const getExtensionFromName = value => {
  if (!value || typeof value !== 'string') return '';
  const cleanValue = value.split('?')[0].split('#')[0];
  const parts = cleanValue.split('.');
  return parts.length > 1 ? parts.pop().toLowerCase() : '';
};

const normalizeAttachment = item => {
  if (!item || typeof item !== 'object') return null;
  const url =
    item.url ||
    item.fileLink ||
    item.file_url ||
    item.asset_url ||
    item.image_url ||
    item.link ||
    '';
  if (!url) return null;

  const name = item.name || item.filename || extractFileNameFromUrl(url) || 'Attachment';
  const extension = item.extension || getExtensionFromName(name) || getExtensionFromName(url);
  const kind =
    item.kind === 'link' || item.type === 'link' || item.isAttachment === false ? 'link' : 'file';

  return {
    url,
    name,
    extension,
    kind,
  };
};

export const parseChatSystemMessage = messageText => {
  if (!messageText || typeof messageText !== 'string') {
    return {
      isSystem: false,
      type: null,
      displayText: '',
      attachments: [],
    };
  }

  const trimmed = messageText.trim();
  if (!trimmed.startsWith('{') && !trimmed.startsWith('[')) {
    return {
      isSystem: false,
      type: null,
      displayText: messageText,
      attachments: [],
    };
  }

  let parsed;
  try {
    parsed = JSON.parse(trimmed);
  } catch (error) {
    return {
      isSystem: false,
      type: null,
      displayText: messageText,
      attachments: [],
    };
  }

  const payload = Array.isArray(parsed)
    ? parsed.find(item => item && typeof item === 'object' && item.type) || parsed[0]
    : parsed;

  if (!payload || typeof payload !== 'object' || !payload.type) {
    return {
      isSystem: false,
      type: null,
      displayText: messageText,
      attachments: [],
    };
  }

  const attachments = Array.isArray(payload?.publicData?.filesAndLinks)
    ? payload.publicData.filesAndLinks.map(normalizeAttachment).filter(Boolean)
    : [];
  const displayText = payload.displayText || 'updated the conversation';
  const normalizedDisplayText =
    typeof displayText === 'string' ? displayText.trim().toLowerCase() : '';
  const conversationUpdateTypes = new Set([
    'CONVERSATION_UPDATED',
    'UPDATE_CONVERSATION',
    'CONVERSATION_UPDATE',
    'CONVERSATION_UPDATED_EVENT',
  ]);
  const isConversationUpdate =
    conversationUpdateTypes.has(payload.type) ||
    (normalizedDisplayText.includes('updated the conversation') && attachments.length === 0);

  return {
    isSystem: true,
    type: payload.type,
    displayText,
    attachments,
    raw: payload,
    shouldRender: !isConversationUpdate,
  };
};
